import RoleDashboard from "../pages/dashboard/RoleDashboard.jsx";
import Client from "../pages/client/Client.jsx";
import ClientDetails from "../pages/client/components/ClientDetails.jsx";
import LiveAccountDetails from "../pages/client/components/LiveAccountDetails.jsx";
import Kyc from "../pages/kyc/Kyc.jsx";
import Accounts from "../pages/accounts/MainMT5.jsx";
import GenerateCommission from "../pages/ibCommission/generateCommission/GenerateCommission.jsx";
import IBCommission from "../pages/ibCommission/generateCommission/components/IBCommission.jsx";
import WithdrawCommission from "../pages/ibCommission/withdrawCommission/WithdrawCommission.jsx";
import Withdraw from "../pages/wallet/Withdraw/Withdraw.jsx";
import Deposit from "../pages/wallet/components/Deposit.jsx";
import InternalTransfer from "../pages/wallet/components/InternalTransfer.jsx";
import EmailTemplate from "../pages/emailTemplate/EmailTemplate.jsx";
import Task from "../pages/task/Task.jsx";
import Banner from "../pages/banner/Banner.jsx";
import AdminLogin from "../pages/auth/Admin_login.jsx";
import ResetPassword from "../pages/authpage/ResetPassword.jsx";
import ForgetPassword from "../pages/authpage/ForgetPassword.jsx";
import UserOtp from "../pages/authpage/Otp.jsx";
import Login from "../pages/authpage/Login.jsx";
import ForgetPasswordotp from "../pages/authpage/forget_otp.jsx";
import Roles from "../pages/settings/roles/Roles.jsx";
import Ticket from "../pages/support/ticket/Ticket.jsx";
import ViewTicket from "../pages/support/ticket/ViewTicket.jsx";
import Faq from "../pages/support/faq/Faq.jsx";
import AccountType from "../pages/accountType/AccountType.jsx";
import Notifications from "../pages/settings/notifications/Notifications.jsx";
import Rules from "../pages/settings/rules/Mainrules.jsx";
import PaymentGateway from "../pages/settings/paymentGateway/PaymentGateway.jsx";
import KycRules from "../pages/settings/kycRules/KycRules.jsx";
import Reminder from "../pages/settings/reminder/Reminder.jsx";
import FAQs from "../pages/support/faq/Faq.jsx";
import IbApproved from "../pages/ibApproved/IbApproved.jsx";
import ParentTree from "../pages/client/components/ParentTree.jsx";
import IbTree from "../pages/client/components/IbTree.jsx";
import OpenedIbTree from "../pages/ibApproved/components/OpenedIbTree.jsx";
import IBAccept from "../pages/ibAccept/IBAccept.jsx";
import ChangePassword from "../pages/client/components/ChangePassword.jsx";
import DepositUser from "../pages/client/components/Deposit.jsx";
import InternalTransferuser from "../pages/client/components/InternalTransfer.jsx";
import Logs from "../pages/client/components/Logs.jsx";
import MT5Account from "../pages/client/components/MT5Account.jsx";
import MT5LoginDetails from "../pages/client/components/MT5LoginDetails.jsx";
import SendCredentials from "../pages/client/components/SendCredentials.jsx";
import SendNotification from "../pages/client/components/SendNotification.jsx";
import Withdrawuser from "../pages/client/components/Withdraw.jsx";
import DepositUSDT from "../pages/client/components/DepositUSDT.jsx";
import Inbox from "../pages/inbox/Inbox.jsx";
import AddEmailTemplate from "../pages/emailTemplate/components/AddEmailTemplate.jsx";
import EditEmailTemplate from "../pages/emailTemplate/components/EditEmailTemplate.jsx";
import IbDetails from "../pages/ibApproved/components/IbDetails.jsx";
import PromotionKit from "../pages/promotionKit/PromotionKit.jsx";
import Reports from "../pages/ibCommission/reports/Reports.jsx";
import Rolback from "../pages/ibCommission/rolback/Rolback.jsx";
import Teams from "../pages/settings/teams/Teams.jsx";
import Tutorial from "../pages/tutorial/Tutorial.jsx";
import Lead from "../pages/salesDashboard/lead/Lead.jsx";
import Source from "../pages/salesDashboard/source/Source.jsx";
import SalesDashboard from "../pages/salesDashboard/dashboard/Dashboard.jsx";
import VolumeReport from "../pages/salesDashboard/reports/VolumeReport.jsx";
import OfficeGoalsReport from "../pages/salesDashboard/reports/OfficeGoalsReport.jsx";
import TeamGoalsReport from "../pages/salesDashboard/reports/TeamGoalsReport.jsx";
import FTDReport from "../pages/salesDashboard/reports/FTDReport.jsx";
import Subadmin from "../pages/SubAdmins/Subadmin.jsx";
import SubadminDetails from "../pages/SubAdmins/SubadminDetails.jsx";
import BankDetails from "../pages/cashDeposite/bankDetails/BankDetails.jsx";
import DepositRequest from "../pages/cashDeposite/request/DepositRequest.jsx";
import UsdConversion from "../pages/cashDeposite/usdConversion/UsdConversion.jsx";
import Configuration from "../pages/settings/configuration/Configuration.jsx";
import Commissiondata from "../pages/Reports/Commissiondata.jsx";
import DepositReminderLog from "../pages/DepositReminderLog/DepositReminderLog.jsx";
import TerminalOnlineUsers from "../pages/TerminalOnlineUsers/TerminalOnlineUsers.jsx";
import InactiveAccounts from "../pages/accounts/InactiveAccounts.jsx";
import IbHandler from "../pages/ibApproved/components/IbHandler.jsx";
import Symbol from "../pages/settings/symbol/Symbol.jsx";
import SymbolDetai from "../pages/settings/symbol/SymbolDetail.jsx";
import EmailTemplateView from "../pages/emailTemplate/EmailTemplateView.jsx";
import Analytics from "../pages/analytics/Analytics.jsx";
import AnalyticsView from "../pages/analytics/AnalyticsView.jsx";
import EmailMarketing from "../pages/emailMarketing/components/EmailMarketing.jsx";
import AddEmail from "../pages/emailMarketing/components/AddEmail.jsx";
import EmailContentPreview from "../pages/emailMarketing/components/EmailContentPreview.jsx";
import EmailUserDetail from "../pages/emailMarketing/components/EmailUserDetail.jsx";
import Credit from "../pages/wallet/components/Credit.jsx";
import IbConfig from "../pages/ibConfig/IbConfig.jsx";
import IbApproveList from "../pages/ibConfig/IbApproveList.jsx";
import ViewTNC from "../pages/client/components/ViewTNC.jsx";
import TNC from "../pages/settings/T&C/TNC.jsx";
import AddTNC from "../pages/settings/T&C/componets/AddTNC.jsx";
import TNCReport from "../pages/Reports/TNCReport.jsx";
import DemoAccouts from "../pages/accounts/DemoAccouts.jsx";
import AssignedToSales from "../pages/SubAdmins/AssignedToSales.jsx";
import SalesOffice from "../pages/settings/salesOffice/SalesOffice.jsx";

export const initialRoutes = () => {
  const routes = [
    // ============ Auth ===============
    { path: "/admin_login", type: "auth", component: AdminLogin },
    { path: "/", type: "auth", component: Login },
    { path: "/otp", type: "auth", component: UserOtp },
    { path: "/forget_password", type: "auth", component: ForgetPassword },
    { path: "/reset_password", type: "auth", component: ResetPassword },
    { path: "/forgotpassword_otp", type: "auth", component: ForgetPasswordotp },
    // ============ Public =============
    // all public routes should be here
    // ============ Privet ==============
    {
      path: "/dashboard",
      type: "private",
      component: RoleDashboard,
      title: "Dashboard",
    },
    {
      path: "/analytics",
      type: "private",
      component: Analytics,
      title: "Analytics",
      module: "analytics",
    },
    {
      path: "/analytics/:loginId",
      type: "private",
      component: AnalyticsView,
      title: "Client Analytics",
      module: "analytics",
      parent: [{ title: "Analytics", path: "/analytics" }],
    },
    {
      path: "/client",
      type: "private",
      component: Client,
      title: "Client",
      module: "client",
    },
    {
      path: "/client_details/:id",
      type: "private",
      component: ClientDetails,
      title: "Client Details",
      module: "client",
      parent: [{ title: "Client", path: "/client" }],
    },
    {
      path: "/account_details/:loginId/:id",
      type: "private",
      component: LiveAccountDetails,
      title: "Account Details",
      module: "client",
      parent: [
        { title: "Client", path: "/client" },
        { title: "Client Details", path: "/client_details/:id" },
      ],
    },
    {
      path: "/kyc",
      type: "private",
      component: Kyc,
      title: "Kyc",
      module: "kyc",
    },
    {
      path: "/terminal_Online_Users",
      type: "private",
      component: TerminalOnlineUsers,
      title: "Terminal Online Users",
    },
    {
      path: "/inactive_Accounts",
      type: "private",
      component: InactiveAccounts,
      title: "Inactive Accounts",
      module: "account",
    },
    {
      path: "/accounts",
      type: "private",
      component: Accounts,
      title: "Live Accounts",
      module: "account",
    },
    {
      path: "/demo_accounts",
      type: "private",
      component: DemoAccouts,
      title: "Demo Accouts",
      module: "account",
    },
    {
      path: "/ib_manager",
      type: "private",
      component: IbApproved,
      title: "IB Manager",
      module: "ib_manager",
    },
    {
      path: "/ib_manager/ib_tree/:userId",
      type: "private",
      component: OpenedIbTree,
      title: "IB Tree",
      module: "ib_manager",
      parent: [{ title: "IB Manager", path: "/ib_manager?filter=Approved" }],
    },
    {
      path: "/ib_config/:type/:id/:planId",
      type: "private",
      component: IbConfig,
      title: "IB Config",
      module: "ib_manager",
      subModule: "plan",
      parent: [{ title: "IB Manager", path: "/ib_manager?filter=Pending" }],
    },
    {
      path: "/ib_details/:type/:id",
      type: "private",
      component: IbApproveList,
      title: "Approved AC Type",
      module: "ib_manager",
      subModule: "plan",
      parent: [{ title: "IB Manager", path: "/ib_manager?filter=Pending" }],
    },
    {
      path: "/ib_details/:id",
      type: "private",
      component: IbDetails,
      title: "IB Details",
      module: "ib_manager",
      parent: [{ title: "IB Manager", path: "/ib_manager?filter=Approved" }],
    },
    {
      path: "/ib_handler/:id",
      type: "private",
      component: IbHandler,
      title: "Update IB",
      module: "ib_manager",
      parent: [{ title: "IB Manager", path: "/ib_manager?filter=Approved" }],
    },
    {
      path: "/ib_accept/:id",
      type: "private",
      component: IBAccept,
      title: "IB Accept",
      module: "ib_manager",
    },
    {
      path: "/ib_commission_generate",
      type: "private",
      component: GenerateCommission,
      title: "Generate Commission",
      module: "commission",
      subModule: "comm_generate",
    },
    {
      path: "/ib_commission/:id",
      type: "private",
      component: IBCommission,
      title: "IB Commission",
      module: "commission",
      subModule: "comm_generate",
      parent: [
        { title: "Generate Commission", path: "/ib_commission_generate" },
      ],
    },
    {
      path: "/ib_commission_withdraw",
      type: "private",
      component: WithdrawCommission,
      title: "Withdraw Commission",
      module: "commission",
      subModule: "comm_withdraw",
    },
    {
      path: "/ib_commission_reports",
      type: "private",
      component: Reports,
      title: "Commission Reports",
      module: "commission",
      subModule: "comm_report",
    },
    {
      path: "/ib_commission_rollback",
      type: "private",
      component: Rolback,
      title: "Commission Rollback",
      module: "commission",
    },
    {
      path: "/wallet_withdraw",
      type: "private",
      component: Withdraw,
      title: "Withdraw",
      module: "wallet",
      subModule: "withdraw",
    },
    {
      path: "/wallet_deposit",
      type: "private",
      component: Deposit,
      title: "Deposit",
      module: "wallet",
      subModule: "deposit",
    },
    {
      path: "/wallet_internal_transfer",
      type: "private",
      component: InternalTransfer,
      title: "Internal Transfer",
      module: "wallet",
      subModule: "internal_transfer",
    },
    {
      path: "/sub_admin",
      type: "private",
      component: Subadmin,
      title: "Sub Admins",
      module: "subadmin",
    },
    {
      path: "/sub_admin/:id",
      type: "private",
      component: SubadminDetails,
      title: "Sub Admin Permissions",
      module: "subadmin",
      action: "update_permission",
      parent: [{ title: "Sub Admins", path: "/sub_admin" }],
    },
    {
      path: "/assigned_to_sales/:id",
      type: "private",
      component: AssignedToSales,
      title: "Assigned To Sales",
      module: "subadmin",
      parent: [{ title: "Sub Admins", path: "/sub_admin" }],
    },
    {
      path: "/email_template",
      type: "private",
      component: EmailTemplate,
      title: "Email Template",
      module: "email_template",
    },
    {
      path: "/email_marketing",
      type: "private",
      component: EmailMarketing,
      title: "Email Marketing",
      module: "email_marketing",
    },
    {
      path: "/email_marketing/preview",
      type: "private",
      component: EmailContentPreview,
      title: "Email Preview",
      module: "email_marketing",
      parent: [{ title: "Email Marketing", path: "/email_marketing" }],
    },
    {
      path: "/email_marketing/user_detail/:sendEmailId",
      type: "private",
      component: EmailUserDetail,
      title: "Email Recipients",
      module: "email_marketing",
      parent: [{ title: "Email Marketing", path: "/email_marketing" }],
    },
    {
      path: "/email_marketing/:id",
      type: "private",
      component: AddEmail,
      title: "Add Email",
      module: "email_marketing",
      parent: [{ title: "Email Marketing", path: "/email_marketing" }],
    },
    {
      path: "/add_email_template",
      type: "private",
      component: AddEmailTemplate,
      title: "Add Email Template",
      module: "email_template",
      parent: [{ title: "Email Template", path: "/email_template" }],
    },
    {
      path: "/edit_email_template/:id",
      type: "private",
      component: EditEmailTemplate,
      title: "Edit Email Template",
      module: "email_template",
      parent: [{ title: "Email Template", path: "/email_template" }],
    },
    { path: "/task", type: "private", component: Task, title: "Task" },
    {
      path: "/banner",
      type: "private",
      component: Banner,
      title: "Banner",
      module: "banner",
    },
    {
      path: "/symbol_detail/:id",
      type: "private",
      component: SymbolDetai,
      title: "Symbol Detail",
      module: "setting",
      subModule: "symbol",
    },
    { path: "/roles", type: "private", component: Roles, title: "Roles" },
    { path: "/teams", type: "private", component: Teams, title: "Manage Team" },
    {
      path: "/ticket",
      type: "private",
      component: Ticket,
      title: "Ticket",
      module: "support",
      subModule: "ticket",
    },
    {
      path: "/tutorial",
      type: "private",
      component: Tutorial,
      title: "Tutorial",
      module: "tutorial",
    },
    {
      path: "/view_ticket/:id",
      type: "private",
      component: ViewTicket,
      title: "View Ticket",
      module: "support",
      subModule: "ticket",
      parent: [{ title: "Ticket", path: "/ticket" }],
    },
    {
      path: "/faq",
      type: "private",
      component: Faq,
      title: "Faq",
      module: "support",
      subModule: "faq",
    },
    {
      path: "/promotion_kit",
      type: "private",
      component: PromotionKit,
      title: "Promotion Kit",
    },
    {
      path: "/account_Type",
      type: "private",
      component: AccountType,
      title: "Account Type",
      module: "account_type",
    },
    {
      path: "/inbox",
      type: "private",
      component: Inbox,
      title: "Inbox",
      module: "inbox",
    },
    {
      path: "/notifications",
      type: "private",
      component: Notifications,
      title: "Notifications",
      module: "setting",
      subModule: "notification",
    },
    {
      path: "/rules",
      type: "private",
      component: Rules,
      title: "Rules",
      module: "setting",
      subModule: "rule",
    },
    {
      path: "/payment_Gateway",
      type: "private",
      component: PaymentGateway,
      title: "Payment Gateway",
      module: "setting",
      subModule: "psp",
    },
    {
      path: "/kyc_Rules",
      type: "private",
      component: KycRules,
      title: "KycRules",
      module: "setting",
    },
    {
      path: "/sales_office",
      type: "private",
      component: SalesOffice,
      title: "Sales Office",
      module: "setting",
      subModule: "sales_office",
    },
    {
      path: "/reminder",
      type: "private",
      component: Reminder,
      title: "Reminder",
      module: "setting",
    },
    {
      path: "/parent_tree/:id",
      type: "private",
      component: ParentTree,
      title: "Parent Tree",
      module: "client",
      parent: [
        { title: "Client", path: "/client" },
        { title: "Client Details", path: "/client_details/:id" },
      ],
    },
    {
      path: "/credit",
      type: "private",
      component: Credit,
      title: "Credit",
      module: "wallet",
      subModule: "credit",
    },
    {
      path: "/ib_tree/:id",
      type: "private",
      component: IbTree,
      title: "Ib Tree",
      module: "client",
      parent: [
        { title: "Client", path: "/client" },
        { title: "Client Details", path: `/client_details/:id` },
      ],
    },
    {
      path: "/change_password",
      type: "private",
      component: ChangePassword,
      title: "Change Password",
      module: "client",
    },
    {
      path: "/internal_transfer/:id",
      type: "private",
      component: InternalTransferuser,
      title: "Internal Transferuser",
      module: "client",
    },
    {
      path: "/deposit/:id",
      type: "private",
      component: DepositUser,
      title: "Deposit",
      module: "client",
      parent: [
        { title: "Client", path: "/client" },
        { title: "Client Details", path: "/client_details/:id" },
      ],
    },
    {
      path: "/deposit_usdt/:paymentId/:id",
      type: "private",
      component: DepositUSDT,
      title: "Deposit USDT",
      module: "client",
      parent: [
        { title: "Client", path: "/client" },
        { title: "Client Details", path: "/client_details/:id" },
        { title: "Deposit", path: "/deposit/:id" },
      ],
    },
    {
      path: "/internal_transfer",
      type: "private",
      component: InternalTransferuser,
      title: "Internal Transferuser",
      module: "client",
    },
    {
      path: "/logs/:id",
      type: "private",
      component: Logs,
      title: "Logs",
      module: "client",
      parent: [
        { title: "Client", path: "/client" },
        { title: "Client Details", path: "/client_details/:id" },
      ],
    },
    {
      path: "/mt5_account/:id",
      type: "private",
      component: MT5Account,
      title: "MT5Account",
      module: "client",
      parent: [
        { title: "Client", path: "/client" },
        { title: "Client Details", path: "/client_details/:id" },
      ],
    },
    {
      path: "/mt5_login_details",
      type: "private",
      component: MT5LoginDetails,
      title: "MT5Login Details",
      module: "client",
    },
    {
      path: "/send_credentials",
      type: "private",
      component: SendCredentials,
      title: "Send Credentials",
      module: "client",
    },
    {
      path: "/send_notification",
      type: "private",
      component: SendNotification,
      title: "Send Notification",
      module: "client",
    },
    {
      path: "/withdraw/:id",
      type: "private",
      component: Withdrawuser,
      title: "Withdraw",
      module: "client",
      parent: [
        { title: "Client", path: "/client" },
        { title: "Client Details", path: "/client_details/:id" },
      ],
    },
    {
      path: "/sales_dashboard",
      type: "private",
      component: SalesDashboard,
      title: "Sales Dashboard",
      module: "sales",
      subModule: "dashboard",
    },
    {
      path: "/volume_report",
      type: "private",
      component: VolumeReport,
      title: "Volume Report",
      module: "sales",
      subModule: "volume_report",
    },
    {
      path: "/office_goals_report",
      type: "private",
      component: OfficeGoalsReport,
      title: "Office Goals Report",
      module: "sales",
      subModule: "office_goals",
    },
    {
      path: "/team_goals_report",
      type: "private",
      component: TeamGoalsReport,
      title: "Team Goals Report",
      module: "sales",
      subModule: "team_goals",
    },
    {
      path: "/ftd_report",
      type: "private",
      component: FTDReport,
      title: "FTD Report",
      module: "sales",
      subModule: "ftd_report",
    },
    {
      path: "/source",
      type: "private",
      component: Source,
      title: "Source",
      module: "sales",
      subModule: "source",
    },
    {
      path: "/leads",
      type: "private",
      component: Lead,
      title: "Lead",
      module: "sales",
      subModule: "leads",
    },
    {
      path: "/bank_details",
      type: "private",
      component: BankDetails,
      title: "Bank Details",
      module: "setting",
      subModule: "bank_detail",
    },
    {
      path: "/deposit_request",
      type: "private",
      component: DepositRequest,
      title: "Deposit Request",
      module: "wallet",
      subModule: "deposit",
    },
    {
      path: "/usd_conversion",
      type: "private",
      component: UsdConversion,
      title: "Usd Conversion",
      module: "setting",
      subModule: "conversion",
    },
    {
      path: "/thres_hold",
      type: "private",
      component: Configuration,
      title: "Thres hold",
      module: "setting",
      subModule: "threshold",
    },
    {
      path: "/symbol",
      type: "private",
      component: Symbol,
      title: "Symbol",
      module: "setting",
      subModule: "symbol",
    },
    {
      path: "/thres_hold_reports",
      type: "private",
      component: Commissiondata,
      title: "Thres hold Reports",
      module: "report",
    },
    {
      path: "/log",
      type: "private",
      component: DepositReminderLog,
      title: "Log",
      module: "log",
    },
    {
      path: "/email_template_view/:id",
      type: "private",
      component: EmailTemplateView,
      title: "Email Template View",
      module: "email_template",
    },
    {
      path: "/terms",
      type: "private",
      component: TNC,
      title: "Terms & Conditions",
      module: "setting",
      subModule: "tnc",
    },
    {
      path: "/terms_report",
      type: "private",
      component: TNCReport,
      title: "Terms & Conditions Report",
      module: "report",
    },
    {
      path: "/add_terms",
      type: "private",
      component: AddTNC,
      title: "Add Terms & Conditions",
      module: "setting",
      subModule: "tnc",
      parent: [{ title: "Terms & Conditions", path: "/terms" }],
    },
    {
      path: "/terms/:version",
      type: "public",
      component: ViewTNC,
      title: "Terms & Conditions",
    },
  ];
  return routes;
};

// export default initialRoutes
